import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const navigate = useNavigate();
  useLanguage();

  const toggleMenu = () => {
    console.log('햄버거 버튼 클릭됨! (영문) 현재 상태:', isMenuOpen);
    const newState = !isMenuOpen;
    setIsMenuOpen(newState);
    console.log('새로운 상태 (영문):', newState);
    
    // DOM에서 클래스 확인
    setTimeout(() => {
      const navElement = document.querySelector('.nav');
      if (navElement) {
        console.log('nav 요소 클래스 (영문):', navElement.className);
        console.log('nav 요소 스타일 (영문):', {
          display: window.getComputedStyle(navElement).display,
          position: window.getComputedStyle(navElement).position,
          opacity: window.getComputedStyle(navElement).opacity,
          visibility: window.getComputedStyle(navElement).visibility
        });
      }
    }, 100);
  };


  const closeDropdown = () => {
    setIsMenuOpen(false);
  };

  const navigateToPage = (path) => {
    navigate(`/en${path}`);
    setIsMenuOpen(false);
  };

  // 섹션으로 스크롤하는 함수 (사이드바와 동일)
  const scrollToSection = (subItem) => {
    if (subItem.sectionId) {
      // 현재 페이지가 맞는지 확인
      const currentPath = window.location.pathname;
      const targetPath = `/en${subItem.path}`;
      
      if (currentPath === targetPath) {
        // 같은 페이지에 있으면 해당 섹션으로 스크롤
        setTimeout(() => {
          const element = document.getElementById(subItem.sectionId);
          if (element) {
            const headerHeight = 100; // 헤더 높이
            const elementPosition = element.offsetTop - headerHeight - 30; // 헤더 높이 + 여백
            window.scrollTo({
              top: elementPosition,
              behavior: 'smooth'
            });
          }
        }, 100);
      } else {
        // 다른 페이지면 페이지 이동 후 스크롤
        navigate(`/en${subItem.path}#${subItem.sectionId}`);
        setTimeout(() => {
          const element = document.getElementById(subItem.sectionId);
          if (element) {
            const headerHeight = 100; // 헤더 높이
            const elementPosition = element.offsetTop - headerHeight - 30; // 헤더 높이 + 여백
            window.scrollTo({
              top: elementPosition,
              behavior: 'smooth'
            });
          }
        }, 500);
      }
    } else {
      // 섹션 ID가 없으면 일반 페이지 이동
      navigate(`/en${subItem.path}`);
    }
    setIsMenuOpen(false);
  };

  const handleLanguageToggle = () => {
    const newLanguage = 'ko';
    const currentPath = window.location.pathname;
    
    console.log('Language toggle to Korean:', { currentPath });
    
    // URL에서 영어 코드 제거하고 한국어로 변경
    let pathWithoutLanguage = currentPath;
    
    if (currentPath.startsWith('/en/')) {
      pathWithoutLanguage = currentPath.replace('/en', '');
    } else if (currentPath === '/en') {
      pathWithoutLanguage = '';
    }
    
    const newPath = `/${newLanguage}${pathWithoutLanguage}`;
    console.log('Navigating to:', newPath);
    
    navigate(newPath);
  };

  // 로고 클릭 시 상단으로 스크롤하는 함수
  const handleLogoClick = (e) => {
    e.preventDefault();
    const currentPath = window.location.pathname;
    
    if (currentPath === '/en') {
      // 메인 페이지에 있으면 상단으로 스크롤
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      // 다른 페이지에 있으면 메인 페이지로 이동 후 상단으로 스크롤
      navigate('/en');
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }, 100);
    }
  };

  // 각 카테고리의 하위 메뉴 데이터 (사이드바와 동일)
  const menuItems = {
    company: {
      ko: '회사소개',
      en: 'Company',
      subItems: [
        { ko: '회사소개', en: 'Company Overview', path: '/company-overview', sectionId: 'company-overview' },
        { ko: '연혁', en: 'Company History', path: '/company-overview', sectionId: 'company-history' },
        { ko: '조직도', en: 'Organization', path: '/company-overview', sectionId: 'organization' },
        { ko: '찾아오시는길', en: 'Location', path: '/company-overview', sectionId: 'company-location' }
      ]
    },
    products: {
      ko: '제품소개',
      en: 'Products',
      subItems: [
        { ko: '판형열교환기', en: 'Plate Heat Exchanger', path: '/products', sectionId: 'heat-exchanger' },
        { ko: '컴팩트 설비 유니트', en: 'Compact Unit', path: '/products', sectionId: 'compact-unit' },
        { ko: '순간온수가열기', en: 'Heating System', path: '/products', sectionId: 'heating-system' },
        { ko: '브레이징 열교환기', en: 'Brazing Heat Exchanger', path: '/products', sectionId: 'brazing-heat-exchanger' },
        { ko: '스파이럴 열교환기', en: 'Spiral Heat Exchanger', path: '/products', sectionId: 'spiral-heat-exchanger' },
        { ko: '용접형 판형열교환기', en: 'Welded Plate Heat Exchanger', path: '/products', sectionId: 'welded-plate-heat-exchanger' },
        { ko: 'GAS COOLER', en: 'Gas Cooler', path: '/products', sectionId: 'gas-cooler' },
        { ko: '밀폐형 팽창탱크', en: 'Closed Expansion Tank', path: '/products', sectionId: 'closed-expansion-tank' },
        { ko: '팽창기수분리기', en: 'Expansion Separator', path: '/products', sectionId: 'expansion-separator' },
        { ko: '플레이트 코일', en: 'Plate Coil', path: '/products', sectionId: 'plate-coil' },
        { ko: '볼탱크', en: 'Spherical Tank', path: '/products', sectionId: 'ball-tank' },
        { ko: 'ATM 탱크', en: 'ATM Tank', path: '/products', sectionId: 'atm-tank' }
      ]
    },
    certification: {
      ko: '인증현황',
      en: 'Certification',
      subItems: [
        { ko: '인증서', en: 'Certificates', path: '/certification-detail', sectionId: null }
      ]
    },
    delivery: {
      ko: '납품실적',
      en: 'Delivery',
      subItems: [
        { ko: '납품실적', en: 'Delivery Performance', path: '/delivery-performance', sectionId: null }
      ]
    },
    support: {
      ko: '고객지원',
      en: 'Support',
      subItems: [
        { ko: '고객센터', en: 'Customer Center', path: '/customer-support', sectionId: 'customer-center' },
        { ko: '온라인견적', en: 'Online Quote', path: '/customer-support', sectionId: 'online-quote' },
        { ko: '자료실', en: 'Document Center', path: '/customer-support', sectionId: 'download-center' }
      ]
    },
    esg: {
      ko: 'ESG',
      en: 'ESG',
      subItems: [
        { ko: '환경', en: 'Environment', path: '/esg', sectionId: 'environment' },
        { ko: '사회', en: 'Social', path: '/esg', sectionId: 'social' },
        { ko: '지배구조', en: 'Governance', path: '/esg', sectionId: 'governance' }
      ]
    }
  };

  return (
    <header className="header en-header">
      <div className="header-container">
        {/* 로고 섹션 */}
        <div className="logo-section">
          <Link to="/en" className="logo-link" onClick={handleLogoClick}>
            <div className="logo">
              <img src="/logo.png" alt="Taibong Industries Inc." className="logo-image" />
            </div>
            <div className="company-info">
              <h1 className="company-name">Taibong Industries Inc.</h1>
              <p className="company-tagline">태봉산업기술(주)</p>
            </div>
          </Link>
        </div>

        {/* 네비게이션 메뉴 */}
        <div className="nav-section">
          <div className="nav-top">
            <span className="nav-separator">
              <span className="mic-icon"></span>
              <button className="nav-top-btn" onClick={handleLanguageToggle}>
                한국어
              </button>
              <span className="nav-divider">|</span>
              <button className="nav-top-btn" onClick={() => navigateToPage('/customer-support')}>
                CONTACT US
              </button>
            </span>
          </div>
          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <ul className="nav-list">
              {/* 메인 메뉴 */}
              {Object.entries(menuItems).map(([key, item]) => (
                <li 
                  key={key}
                  className="nav-item"
                  onMouseEnter={() => setHoveredItem(key)}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <button 
                    onClick={() => navigateToPage(item.subItems[0].path)} 
                    className="nav-link"
                  >
                    {item.en}
                    <span className="nav-arrow">▼</span>
                  </button>
                  
                  {/* 드롭다운 메뉴 */}
                  {hoveredItem === key && (
                    <div className="dropdown-menu">
                      <ul className="dropdown-list">
                        {item.subItems.map((subItem, index) => (
                          <li key={index} className="dropdown-item">
                            <button 
                              onClick={() => scrollToSection(subItem)}
                              className="dropdown-link"
                            >
                              {subItem.en}
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </li>
              ))}
            </ul>
            
            {/* 모바일용 풀스크린 메뉴 */}
            {isMenuOpen && (
              <div className="fullscreen-dropdown" onClick={closeDropdown}>
                <div className="dropdown-content" onClick={(e) => e.stopPropagation()}>
                  {/* 언어 변경 및 문의하기 버튼 */}
                  <div className="dropdown-top-buttons">
                    <button className="top-btn" onClick={handleLanguageToggle}>
                      한국어
                    </button>
                    <button className="top-btn" onClick={() => navigateToPage('/customer-support')}>
                      CONTACT US
                    </button>
                  </div>
                  
                  {/* 메인 카테고리 */}
                  <div className="dropdown-section">
                    <button onClick={() => navigateToPage('/company-overview')}>Company</button>
                  </div>
                  <div className="dropdown-section">
                    <button onClick={() => navigateToPage('/products')}>Products</button>
                  </div>
                  <div className="dropdown-section">
                    <button onClick={() => navigateToPage('/certification-detail')}>Certification</button>
                  </div>
                  <div className="dropdown-section">
                    <button onClick={() => navigateToPage('/delivery-performance')}>Delivery</button>
                  </div>
                  <div className="dropdown-section">
                    <button onClick={() => navigateToPage('/customer-support')}>Support</button>
                  </div>
                  <div className="dropdown-section">
                    <button onClick={() => navigateToPage('/esg')}>ESG</button>
                  </div>
                </div>
              </div>
            )}
          </nav>
        </div>

        {/* 모바일 메뉴 버튼 */}
        <button className="mobile-menu-btn" onClick={toggleMenu}>
          <span className="hamburger"></span>
          <span className="hamburger"></span>
          <span className="hamburger"></span>
        </button>
      </div>
    </header>
  );
};

export default Header;
